/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Page_SubtitleInputs */

const vi_stocktake_page_subtitle = /** @type {(inputs: Stocktake_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đếm thực tế và đối chiếu với chốt sổ hôm trước`)
};

/**

* @param {Stocktake_Page_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_page_subtitle = /** @type {((inputs?: Stocktake_Page_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Page_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_page_subtitle(inputs)
});